// extracted by mini-css-extract-plugin
export var legendIndicator = "_fx-1";
export var legendRight = "_fx-0";